<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      serial-width="100"
      :selection="hasBtn && selection"
      :stripe="false"
      right-toolbar-hide
      :hide-search="hideSearch"
      row-key="id"
      :reset-data="resetDataFn"
      tree-select-auto-parent
      lazy
      :load="loadMethod"
      :row-style="$treeRowStyleFun"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessOrderAuditComSkuList.receivingStatus')" prop="receiveStatus">
            <BjSelectLov
              v-model="queryParams.receiveStatus"
              constant-key="ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST"
            />
          </el-form-item>
        </el-col>
        <template v-if="businessType == ORDER_BUSINESS_TYPES.COMMON">
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessOrderAuditComSkuList.deliveryStatus')" prop="deliveryStatus">
              <BjSelectLov
                v-model="queryParams.deliveryStatus"
                constant-key="ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST"
              />
            </el-form-item>
          </el-col>

          <el-col :span="colSpan">
            <!-- #ifndef OPEN-SOURCE -->
            <el-form-item :label="$t('BusinessOrderAuditComSkuList.preemptionStatus')" prop="preemptionStatus">
              <BjSelectLov
                v-model="queryParams.preemptionStatus"
                constant-key="ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessOrderAuditComSkuList.sourceStatus')" prop="sourceStatus">
              <BjSelectLov
                v-model="queryParams.sourceStatus"
                constant-key="ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #endif -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessOrderAuditComSkuList.suspendStatus')" prop="suspendStatus">
              <BjSelectLov
                v-model="queryParams.suspendStatus"
                constant-key="ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #ifndef OPEN-SOURCE -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessOrderAuditComSkuList.syncPreempStatus')" prop="syncPreempStatus">
              <BjSelectLov
                v-model="queryParams.syncPreempStatus"
                constant-key="ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #endif -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessOrderAuditComSkuList.syncDeliveryStatus')" prop="syncDeliveryStatus">
              <BjSelectLov
                v-model="queryParams.syncDeliveryStatus"
                constant-key="ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
        </template>
      </template>
      <template v-if="hasBtn" #startBtnGroup>
        <!-- TODO:添加商品 -->
        <!-- <el-button type="primary" @click="onAction('添加商品')">添加商品</el-button> -->
        <!-- 1.点击时验证选择的商品行状态，如果商品行审核状态非待审核则报错，请选择待审核的商品 -->
        <!-- <el-button type="primary" @click="onAction('审核通过')" class="main-btn">审核通过</el-button>
        <el-button type="primary" @click="onAction('审核拒绝')">审核拒绝</el-button>
        <el-button type="primary" @click="onAction('退回审核')">退回审核</el-button> -->
        <el-button type="primary" @click="onAction($t('BusinessOrderAuditComSkuList.receipt'))">{{ $t('BusinessOrderAuditComSkuList.receipt') }}</el-button>
        <el-button type="primary" @click="onAction($t('BusinessOrderAuditComSkuList.hangUp'))">{{ $t('BusinessOrderAuditComSkuList.hangUp') }}</el-button>
        <el-button type="primary" @click="onAction($t('BusinessOrderAuditComSkuList.hang'))">{{ $t('BusinessOrderAuditComSkuList.hang') }}</el-button>
      </template>

      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'spuName'">
                <el-tag v-if="scope.row.setFlag == 1">{{ $t('BusinessOrderAuditComSkuList.cover') }}</el-tag>
                {{ scope.row[col.prop] }}
              </template>

              <template v-else-if="col.prop === 'giftFlag'">
                <el-tag :type="scope.row.giftFlag ? 'success' : 'info'">{{
                  $t(STATUS_YES_NUM.bjGet(!!scope.row.giftFlag))
                }}</el-tag>
              </template>

              <template v-else-if="col.prop === 'refundFlag'">
                <el-tag :type="scope.row.refundFlag ? 'success' : 'info'">{{
                  $t(STATUS_YES_NUM.bjGet(!!scope.row.refundFlag))
                }}</el-tag>
              </template>

              <template
                v-else-if="
                  col.prop.toLocaleLowerCase().includes('amount') ||
                    col.prop.toLocaleLowerCase().includes('price')
                "
              >
                {{ $number2money(scope.row[col.prop]) }}
              </template>

              <template v-else-if="col.prop === 'deliveryStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <template v-else-if="col.prop === 'receivingStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <template v-else-if="col.prop === 'preemptionStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <template v-else-if="col.prop === 'sourceStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <template v-else-if="col.prop === 'suspendStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <template v-else-if="col.prop === 'syncPreempStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <template v-else-if="col.prop === 'syncDeliveryStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="onDetail(scope.row)">{{ $t('viewText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import {
  STATUS_YES_NUM,
  ORDER_INTERNAL_ORDER_STATUS_LIST,
  ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST,
  ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST,
  ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST,
  ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST,
  ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST,
  ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST,
  ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
  ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
  ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
  ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
  ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
  ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
  ORDER_BUSINESS_TYPES,
} from '@/utils/constants';

export default {
  name: 'BusinessOrderInternalViewSkuList',
  components: {},
  mixins: [pageMiXin],
  props: {
    orderId: {
      type: String,
      default: null,
    },
    hasBtn: {
      type: Boolean,
      default: true,
    },
    hideSearch: {
      type: Boolean,
      default: false,
    },
    businessType: {
      type: String,
      default: ORDER_BUSINESS_TYPES.COMMON,
    },
  },
  data() {
    return {
      sortTableByOptionName: true,
      serial: true,
      STATUS_YES_NUM,
      ORDER_INTERNAL_ORDER_STATUS_LIST,
      ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST,
      ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST,
      ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST,
      ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST,
      ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST,
      ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST,

      ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
      ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
      ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
      ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
      ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
      ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
      ORDER_BUSINESS_TYPES,
      queryApi: orderApi.getInternalSkuListByAuditId,
      // 查询参数
      queryParams: {
        deliveryStatus: null,
        isOutStock: null,
        refundFlag: null,
        auditId: null,
        preemptionStatus: null,
        receiveStatus: null,
        sourceStatus: null,
        suspendStatus: null,
        syncDeliveryStatus: null,
        syncPreempStatus: null,
      },
      labelsVersion: 11,

      selectedRows: null,
    };
  },
  computed: {
    labelList() {
      const ARR = [
        { label: 'goodsPage.skuCode', prop: 'skuCode', isCheck: true, disabled: false, width: 114 },
        { label: 'BusinessOrderAuditComSkuList.giftFlag', prop: 'giftFlag', isCheck: true, disabled: false, width: '86' },
        { label: 'BusinessOrderAuditComSkuList.quantity', prop: 'quantity', isCheck: true, disabled: false, width: '81' },
        { label: 'BusinessOrderAuditComSkuList.thirdSaleAmount', prop: 'thirdSaleAmount', isCheck: true, disabled: false, width: '159' },
        { label: 'BusinessOrderAuditComSkuList.outBalancePrice', prop: 'outBalancePrice', isCheck: true, disabled: false, width: '192' },
        { label: 'BusinessOrderAuditComSkuList.innerSalePrice', prop: 'innerSalePrice', isCheck: true, disabled: false, width: '111' },
        { label: 'BusinessOrderAuditComSkuList.innerBalancePrice', prop: 'innerBalancePrice', isCheck: true, disabled: false, width: '159' },
        { label: 'BusinessOrderAuditComSkuList.costAmount', prop: 'costAmount', isCheck: true, disabled: false, width: '81' },
        { label: 'BusinessOrderAuditComSkuList.totalCostAmount', prop: 'totalCostAmount', isCheck: true, disabled: false, width: '86' },
        { label: 'BusinessOrderAuditComSkuList.transPrice', prop: 'transPrice', isCheck: true, disabled: false, width: '74' },
        { label: 'BusinessOrderAuditComSkuList.deliveryStatus', prop: 'deliveryStatus', isCheck: true, disabled: false, width: '114' },
        { label: 'BusinessOrderAuditComSkuList.receivingStatus', prop: 'receivingStatus', isCheck: true, disabled: false, width: '109' },
        { label: 'BusinessOrderAuditComSkuList.preemptionStatus', prop: 'preemptionStatus', isCheck: true, disabled: false, width: '180' },
        { label: 'BusinessOrderAuditComSkuList.sourceStatus', prop: 'sourceStatus', isCheck: true, disabled: false, width: '171' },
        { label: 'BusinessOrderAuditComSkuList.suspendStatus', prop: 'suspendStatus', isCheck: true, disabled: false, width: '142' },
        { label: 'BusinessOrderAuditComSkuList.syncPreempStatus', prop: 'syncPreempStatus', isCheck: true, disabled: false, width: '173' },
        { label: 'BusinessOrderAuditComSkuList.syncDeliveryStatus', prop: 'syncDeliveryStatus', isCheck: true, disabled: false, width: '181' },
      ];
      if (this.businessType == ORDER_BUSINESS_TYPES.O2O) {
        ARR[0].width = 'auto';

        const NOT_IN_O2O_STR =
          'deliveryStatus,preemptionStatus,sourceStatus,suspendStatus,syncPreempStatus,syncDeliveryStatus';
        NOT_IN_O2O_STR.split(',').forEach(key => {
          const INDEX = ARR.findIndex(col => col.prop == key);
          if (INDEX > -1) {
            ARR.splice(INDEX, 1);
          }
        });
      }
      return ARR;
    },
  },
  watch: {},
  created() {
    this.queryParams.auditId = this.orderId;
  },
  methods: {
    resetDataFn(data) {
      return data.map(e => {
        return { BJ_HAS_CHILD: true, BJ_PARENT_ID: null, ...e };
      });
    },

    loadMethod({ row }) {
      // 异步加载子节点
      return new Promise((resolve, reject) => {
        orderApi
          .getInternalSkuLineListByAuditIdSku({
            itemId: row.id,
            auditId: this.orderId,
          })
          .then(res => {
            const TEMP = (Array.isArray(res) ? res : []).map(e => {
              return { ...e, BJ_HAS_CHILD: false, BJ_PARENT_ID: row.id };
            });

            if (TEMP.length) {
              resolve(TEMP);
            } else {
              this.$message.warning(this.$t('BusinessOrderAuditComSkuList.msgWarning'));
              reject();
            }
          });
      });
    },
    handleSelectionChange(data) {
      this.selectedRows = data;
    },
    onAction(action) {
      const hasChildren = true;
      this.$emit('onAction', action, hasChildren, this.selectedRows);
    },
  },
};
</script>
